/**
 * api 公共函数
 */
import qs from "qs";

/**
 * @param {("GET"|"get"|"POST"|"post")} method
 * @param {string} url
 * @param {Record<string,any>} [params]
 * @param {boolean} [isFormData]
 * @param {boolean} [isPyRequest]
 * @returns {{method: string, url: string, params: *, noCancelable: boolean, isFormData: boolean, isPyRequest: boolean, isFPyRequest: boolean}}
 */
export function useConfig(method, url, params = {}, isFormData = false, isPyRequest = true) {
  return {
    method,
    url,
    params,
    noCancelable: false,
    isFormData: isFormData,
    isPyRequest: isPyRequest,
    isFPyRequest: false,
  };
}

/**
 * @param {string} path
 * @param {Record<string,any>} query
 */
export function useExport(path, query) {
  query.token = localStorage.getItem("token") || "";
  const url = `${process.env.VUE_APP_PY_CN_API_URL}${path}?${qs.stringify(query)}`;
  window.open(url);
}
